var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"font-size-sm mb-0 color-primary clickable",on:{"click":_vm.openMortgage}},[_vm._v("\n  "+_vm._s(_vm.cellProps)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }